import { createSlice } from '@reduxjs/toolkit'
import { actionPlanReview } from 'legacy/lut/features/partner360/commitment/api/actionPlanReview'

import { RequestStatus } from '../../../configs/service'

import { requestAcknowledgement } from './api/requestAcknowledgement'
import {
  commitmentItemsFulfilled,
  commitmentItemsPending,
  commitmentItemsRejected,
  commitmentStatusesFulfilled,
  commitmentStatusesPending,
  commitmentStatusesRejected,
} from './commitmentDataLifecycle'
import { PARTNER360_COMMITMENT_NAMESPACE } from './constants'
import { initialState } from './initialState'

const commitmentSlice = createSlice({
  name: PARTNER360_COMMITMENT_NAMESPACE,
  initialState,
  reducers: {
    resetCommitmentItems: (state) => {
      state.commitmentItems.status = RequestStatus.FULFILLED
      state.commitmentItems.message = 'Data is wiped.'
      state.commitmentItems.data = []
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(commitmentItemsPending, (state) => {
        state.commitmentItems.status = RequestStatus.PENDING
        state.commitmentItems.message = 'Fetching data...'
        state.commitmentItems.data = []
      })
      .addCase(commitmentItemsRejected, (state, action) => {
        state.commitmentItems.status = RequestStatus.REJECTED
        if (action.payload) {
          state.commitmentItems.message = action.payload
        }
      })
      .addCase(commitmentItemsFulfilled, (state, action) => {
        state.commitmentItems.status = RequestStatus.FULFILLED
        state.commitmentItems.message = 'Commitment data fetched successful.'
        state.commitmentItems.data = action.payload
      })

      .addCase(commitmentStatusesPending, (state) => {
        state.commitmentStatuses.status = RequestStatus.PENDING
        state.commitmentStatuses.message = 'Fetching data...'
      })
      .addCase(commitmentStatusesRejected, (state, action) => {
        state.commitmentStatuses.status = RequestStatus.REJECTED
        if (action.payload) {
          state.commitmentStatuses.message = action.payload
        }
      })
      .addCase(commitmentStatusesFulfilled, (state, action) => {
        state.commitmentStatuses.status = RequestStatus.FULFILLED
        state.commitmentStatuses.message = 'Commitment data fetched successful.'
        state.commitmentStatuses.data = action.payload
      })

      .addCase(actionPlanReview.pending, (state) => {
        state.commitmentStatuses.status = RequestStatus.PENDING
        state.commitmentStatuses.message = 'Fetching data...'
      })
      .addCase(actionPlanReview.rejected, (state, action) => {
        state.commitmentStatuses.status = RequestStatus.REJECTED
        if (action.error.message) {
          state.commitmentStatuses.message = action.error.message
        }
      })
      .addCase(actionPlanReview.fulfilled, (state, action) => {
        state.commitmentStatuses.status = RequestStatus.FULFILLED
        state.commitmentStatuses.message = 'Commitment data fetched successful.'
        state.commitmentStatuses.data = state.commitmentStatuses.data.map((item) => {
          const found = action.payload.find((el) => el.ProgramType === item.ProgramType)
          return found || item
        })
      })

      .addCase(requestAcknowledgement.pending, (state) => {
        state.commitmentItems.status = RequestStatus.PENDING
        state.commitmentItems.message = 'Call acknowledgement action.'
      })
      .addCase(requestAcknowledgement.rejected, (state, action) => {
        state.commitmentItems.status = RequestStatus.REJECTED
        if (action.error.message) {
          state.commitmentItems.message = action.error.message
        }
      })
      .addCase(requestAcknowledgement.fulfilled, (state, action) => {
        state.commitmentItems.status = RequestStatus.FULFILLED
        state.commitmentItems.message = 'Acknowledgement went successful.'
        state.commitmentItems.data = action.payload
      }),
})

export const { resetCommitmentItems } = commitmentSlice.actions

export default commitmentSlice.reducer
